<button class="sidebar-button" type="button">
  <span class="sidebar-button__title"><ng-content></ng-content></span>
</button>
